<template>
  <article class="relative flex flex-col pt-37.5 mb-25">
    <div @click="setRoute('main')" class="flex absolute top-22.5 left-4.5">
      <svg class="mr-5 transform rotate-90 w-3" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 6L7 12L13 6" stroke="#323749" stroke-linejoin="round"/>
        <path d="M6.99998 0V12" stroke="#323749" stroke-linejoin="round"/>
      </svg>
      <p class="uppercase font-medium fz-10" style="letter-spacing: 0.1rem; color:rgba(110, 117, 141, 1) ">{{ text.home }}</p>
    </div>
    <div class="flex justify-between mx-4.5">
        <h1 style="color: #f22959; line-height: 1.33;" class="font-light fz-30 capitalize">{{text.blog}}</h1>
        <img src="@/assets/images/volume.svg" class="w-10 h-10"  alt="">
    </div>
    <div class="tags mt-7.5 mb-12.5">
        <div class="flex px-4.5 w-full overflow-auto gap-2.5">
          <p
            v-for="item in Object.entries(text.tags)"
            :key="item[0]"
            @click="setTopic(item[0])"
            :class="{ 'active': activeTopic === item[0] }"
            style="line-height: 1;"
            class="tag w-full cursor-pointer whitespace-nowrap font-semibold fz-10 uppercase py-3.75 px-5 rounded-full border"
          >
            {{ item[1] }}
          </p>
        </div>
    </div>
    <div class="post-previews flex flex-col gap-y-25 mb-25">
        <div
            class="post-preview flex flex-col gap-7.5"
            v-for="item in posts.active"
            :key="item.id"
            @click="setPost(item.id)"
            >
            <img :src="require('@/assets/images/blog/' + item.id + '/' + item.preview)" alt="">
            <div class="content flex flex-col mx-4.5">
                <span class="mb-5 text-gray fz-10" style="line-height:1">{{item.date}}</span>
                <p class="fz-20" style="line-height:1.5">{{item.title}}</p>
            </div>
            <div class="tags flex gap-x-2.5 px-4.5 overflow-auto">
                <p
                    v-for="subItem in item.tags"
                    :key="subItem"
                    class="py-1.25 px-3.75 rounded-full border fz-13" style="line-height:1.5384; border-color:rgba(151, 163, 203, 0.3)">
                        {{text.tags[subItem]}}
                    </p>
            </div>
        </div>
    </div>
    <p class="uppercase fz-13 font-semibold mx-auto" v-if="all.length === 0" style="line-height: 1.5384;">{{text.noPosts}}</p>
    <div class="show-more ml-4.5 flex items-center" @click="expandMax()" v-if="posts.left.length > 1">
        <div class="plus relative w-12.5 h-12.5 mr-5 rounded-full" style="background:#ff2e53;" >
            <div class="w-4 h-2px absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#fff;"></div>
            <div class="w-2px h-4 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#fff;"></div>
        </div>
        <p class="uppercase fz-13 font-semibold mr-5" style="line-height: 1.5384;">{{text.show[0] + (addDefault &lt;= posts.left.length ? addDefault : posts.left.length) + text.show[1] + posts.left.length + text.show[2]}}</p>
    </div>
  </article>
  <slide7  @openContact="toggleContacts"/>
</template>

<script>
import slide7 from "@/components/mobile/main/slide7";
import {mapMutations, mapState} from "vuex";

export default {
  name: "Blog",
  data(){
    return{
      activeTopic:"all",
      addDefault: 5,
      max:5
    }
  },
  components:{
    slide7
  },
  methods:{
    ...mapMutations(['setPost', 'setRoute', 'toggleContacts']),
    expandMax(){
      let result = this.addDefault
      if (this.addDefault > this.posts.left.length){
        result = this.posts.left.length
      }
      this.max+=result
    },
    setTopic(item){
      this.activeTopic = item
      this.max = this.addDefault
    }
  },
  computed:{
    ...mapState(['lang']),
    add(){
      let result = this.addDefault
      if (this.max + this.addDefault > this.posts.active.length){
        result = this.posts.active.length - this.max
      }
      return result
    },
    text(){
      return {
        ...require("@/assets/text/blog/posts/" + this.lang + ".json")
      };
    },
    all(){
        return this.text.posts.filter(item=>item.tags.includes(this.activeTopic) || this.activeTopic === 'all')
    },
    posts(){
        return {
            left: this.all.slice(this.max, this.all.length),
            active: this.all.length > this.max ? this.all.slice(0, this.max) : this.all
        }
    }
  }
}
</script>

<style scoped>
textarea:focus,
input:focus {
  outline: none;
}
.tag{
  transition: all 0.3s linear;
  border-color: rgba(151, 163, 203, 0.3);
}
.tag:hover {
  background: rgba(151, 163, 203, 0.5);
}
.tag.active {
  background: rgba(151, 163, 203, 0.5);
}
</style>
